var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVizCapitalOverTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 294.738,
    height: 126.424,
    viewBox: "0 0 294.738 126.424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M1.36912 55.3487H291.283",
    stroke: "#0C45CC",
    strokeOpacity: 0.1,
    strokeWidth: 0.9125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M1.36912 19.7611H291.283",
    stroke: "#0C45CC",
    strokeOpacity: 0.1,
    strokeWidth: 0.9125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M1.36912 67.2111H291.283",
    stroke: "#0C45CC",
    strokeOpacity: 0.1,
    strokeWidth: 0.9125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M1.36912 31.6237H291.283",
    stroke: "#0C45CC",
    strokeOpacity: 0.1,
    strokeWidth: 0.9125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M1.36912 79.0737H291.283",
    stroke: "#0C45CC",
    strokeOpacity: 0.1,
    strokeWidth: 0.9125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M1.36912 43.4862H291.283",
    stroke: "#0C45CC",
    strokeOpacity: 0.1,
    strokeWidth: 0.9125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M1.36912 90.9361H291.283",
    stroke: "#0C45CC",
    strokeOpacity: 0.1,
    strokeWidth: 0.9125
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M54.7554 85.176L1.36912 91.5635V106.392H293.369V14.4572L279.442 28.1447L252.053 36.3572L229.77 50.501L210.272 64.6447L187.525 56.8885H173.134L143.887 59.626H130.425L117.891 64.6447L110.463 73.7697L96.536 81.9822L89.5726 78.3322H78.4311H69.1465L54.7554 85.176Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M59.8605 67.2727L1.36912 86.2313V126.424H293.369V1.3688L276.461 14.9107L258.183 42.8973L231.222 55.9878L216.142 59.5989H207.003L193.294 71.3352L179.128 78.5576H172.731L161.307 71.3352L137.544 67.2727H122.465H96.8746L82.7087 71.3352L59.8605 67.2727Z",
    fill: "url(#paint1_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M1.36912 91.5635L54.7554 85.176L69.1465 78.3322H78.4311H89.5726L96.536 81.9822L110.463 73.7697L117.891 64.6447L130.425 59.626H143.887L173.134 56.8885H187.525L210.272 64.6447L229.77 50.501L252.053 36.3572L279.442 28.1447L293.369 14.4572",
    stroke: "#0C45CC",
    strokeWidth: 2.7375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M1.36912 86.2313L59.8605 67.2727L82.7087 71.3352L96.8746 67.2727H122.465H137.544L161.307 71.3352L172.731 78.5576H179.128L193.294 71.3352L207.003 59.5989H216.142L231.222 55.9878L258.183 42.8973L276.461 14.9107L293.369 1.3688",
    stroke: "#22D3EE",
    strokeWidth: 2.7375,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 140.684,
    y1: 14.4572,
    x2: 146.472,
    y2: 106.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1384FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871778,
    stopColor: "#1384FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 129.575,
    y1: -95.3348,
    x2: 147.369,
    y2: 126.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41FFE6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVizCapitalOverTime);
export default __webpack_public_path__ + "static/media/viz_capital_over_time.68f777c3019b1eaa9f59612d4fc18905.svg";
export { ForwardRef as ReactComponent };